var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "UserManage app-container" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "用户管理", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "role-top" },
        [
          _c(
            "div",
            { staticClass: "role-top-userName" },
            [
              _c("p", { staticClass: "role-top-userName-title" }, [
                _vm._v("用户名称")
              ]),
              _c("el-input", {
                staticStyle: { width: "224px" },
                attrs: {
                  placeholder: "请输入用户名称",
                  clearable: "",
                  size: "small"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.topSeach($event)
                  }
                },
                model: {
                  value: _vm.userManageName,
                  callback: function($$v) {
                    _vm.userManageName = $$v
                  },
                  expression: "userManageName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "role-top-userId" },
            [
              _c("p", { staticClass: "role-top-userName-title" }, [
                _vm._v("用户编号")
              ]),
              _c("el-input", {
                staticStyle: { width: "224px" },
                attrs: {
                  placeholder: "请输入用户编号",
                  clearable: "",
                  size: "small"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.topSeach($event)
                  }
                },
                model: {
                  value: _vm.userManageId,
                  callback: function($$v) {
                    _vm.userManageId = $$v
                  },
                  expression: "userManageId"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "role-top-userId" },
            [
              _c("p", { staticClass: "role-top-userName-title" }, [
                _vm._v("用户状态")
              ]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "224px" },
                  attrs: {
                    placeholder: "请选择用户状态",
                    clearable: "",
                    size: "small"
                  },
                  model: {
                    value: _vm.userStatus,
                    callback: function($$v) {
                      _vm.userStatus = $$v
                    },
                    expression: "userStatus"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "有效", value: "VALID" } }),
                  _c("el-option", {
                    attrs: { label: "失效", value: "INVALID" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("input", {
            staticClass: "btn btn-red search-btn role-top-btn-item",
            staticStyle: { height: "32px" },
            attrs: { type: "button", value: "查询" },
            on: { click: _vm.topSeach }
          }),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "20px" },
              on: { click: _vm.resetForm }
            },
            [
              _c("reset", {
                staticClass: "reset-icon",
                staticStyle: { "vertical-align": "bottom" }
              }),
              _vm._v(" 重置 ")
            ],
            1
          ),
          _c("input", {
            staticClass: "btn btn-red add-btn role-top-btn-item",
            staticStyle: { height: "32px" },
            attrs: { type: "button", value: "新增" },
            on: { click: _vm.addTable }
          }),
          _c("input", {
            staticClass: "btn btn-export  role-top-btn-item",
            staticStyle: { height: "32px" },
            attrs: { type: "button", value: "导出" },
            on: { click: _vm.exportFile }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "UserManage-content" },
        [
          _c(
            "div",
            { staticClass: "UserManage-content-left dict-tree" },
            [
              _c(
                "el-scrollbar",
                { staticStyle: { height: "100%" } },
                [
                  _vm.dataTree && _vm.dataTree.length > 0
                    ? _c("el-tree", {
                        ref: "tree",
                        attrs: {
                          "node-key": "pathId",
                          props: _vm.defaultProps,
                          load: _vm.loadNode,
                          "default-expanded-keys": _vm.openList,
                          "expand-on-click-node": false,
                          lazy: ""
                        },
                        on: { "node-click": _vm.saveOrgId },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var node = ref.node
                                var data = ref.data
                                return _c(
                                  "div",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(data.orgName)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsisspan",
                                            staticStyle: {
                                              "line-height": "20px",
                                              display: "inline-block",
                                              width: "170px"
                                            }
                                          },
                                          [_vm._v(_vm._s(node.label))]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1355556515
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "UserManage-content-right" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.showTable,
                      expression: "showTable"
                    }
                  ],
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "highlight-current-row": "",
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                    height: _vm.tableheight,
                    border: ""
                  },
                  on: {
                    select: _vm.getSelectRow,
                    "header-dragend": _vm.headerdragend,
                    "selection-change": _vm.handleSelectionChange
                  }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "100%",
                          width: "100%",
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c("no-data", {
                          attrs: { height: "400px", width: "400px" }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("el-table-column", {
                    attrs: { fixed: "left", type: "selection", width: "50" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "用户名称", "min-width": "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(
                                        scope.row.userName +
                                          "/" +
                                          scope.row.userId
                                      )
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.userName +
                                        "/" +
                                        scope.row.userId
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "branchName",
                      label: "所属机构",
                      "min-width": "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(scope.row.branchName)
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(_vm._s(scope.row.branchName))
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pathName",
                      label: "所属部门",
                      "min-width": "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(scope.row.pathName)
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(_vm._s(scope.row.pathName))
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属条线",
                      "min-width": "80",
                      prop: "busLineName",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(scope.row.busLineName)
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(_vm._s(scope.row.busLineName))
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "职级",
                      "min-width": "80",
                      prop: "mngLevel",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(
                                        _vm.mngInfo[scope.row.mngLevel]
                                      )
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(
                                    _vm._s(_vm.mngInfo[scope.row.mngLevel])
                                  )
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jobName",
                      label: "职位",
                      "min-width": "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.ToBreak(
                                        scope.row.jobList == null
                                          ? ""
                                          : scope.row.jobList.length > 0
                                          ? _vm.getLevelInfo(scope.row.jobList)
                                          : ""
                                      )
                                    )
                                  },
                                  slot: "content"
                                }),
                                _c("div", { staticClass: "line" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.jobList == null
                                        ? ""
                                        : scope.row.jobList.length > 0
                                        ? _vm.getLevelInfo(scope.row.jobList)
                                        : ""
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "用户状态",
                      "min-width": "80",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", {
                              class:
                                scope.row.userStatus &&
                                scope.row.userStatus == "VALID"
                                  ? "statusicon"
                                  : "unstatusicon"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "statustitle" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.userStatus == "VALID"
                                    ? "有效"
                                    : "失效"
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "65", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: "userManage-" + scope.row.id,
                                attrs: {
                                  placement: "right",
                                  width: "150",
                                  trigger: "click",
                                  "popper-class": "table-popper"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "op-tips" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item ",
                                        on: {
                                          click: function($event) {
                                            return _vm.showUserInfo(scope)
                                          }
                                        }
                                      },
                                      [
                                        _c("operate-view-icon", {
                                          staticClass: "svgOperateIcon"
                                        }),
                                        _vm._v(" 查看")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item ",
                                        on: {
                                          click: function($event) {
                                            return _vm.editUserInfo(scope)
                                          }
                                        }
                                      },
                                      [
                                        _c("operate-edit-icon", {
                                          staticClass: "svgOperateIcon"
                                        }),
                                        _vm._v(" 编辑用户信息")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-popconfirm",
                                      {
                                        attrs: { title: "确定删除该用户？" },
                                        on: {
                                          onConfirm: function($event) {
                                            return _vm.delUserInfo(scope, true)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "op-item ",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _c("delIcon", {
                                              staticStyle: {
                                                margin: "0px 3px 2px 2px"
                                              }
                                            }),
                                            _vm._v(" 删除用户")
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("operate", {
                                  staticClass: "operate-icon",
                                  attrs: { slot: "reference" },
                                  slot: "reference"
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              ),
              _c("div", { staticClass: "role-footer" }, [
                _c(
                  "div",
                  { staticClass: "role-footer-left" },
                  [
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: "删除用户无法恢复，是否要删除？" },
                        on: {
                          onConfirm: function($event) {
                            return _vm.delRole()
                          }
                        }
                      },
                      [
                        _c("input", {
                          staticClass: "btn btn-del",
                          attrs: {
                            slot: "reference",
                            type: "button",
                            value: "删除"
                          },
                          slot: "reference"
                        })
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "role-footer-right" },
                  [
                    _vm.pageshow
                      ? _c("el-pagination", {
                          attrs: {
                            background: "",
                            layout: "total, sizes, prev, pager, next, jumper",
                            "page-sizes": [10, 20, 50, 100, 1000, 2000],
                            total: _vm.total,
                            "current-page": _vm.pageNum,
                            "hide-on-single-page": false
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.pageNum = $event
                            },
                            "update:current-page": function($event) {
                              _vm.pageNum = $event
                            },
                            "current-change": _vm.currentChange,
                            "size-change": _vm.sizeChange
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.showUser
            ? _c(
                "div",
                [
                  _c(
                    "el-dialog",
                    {
                      directives: [
                        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                      ],
                      staticClass: "dialog_footer_page",
                      attrs: {
                        title: "用户详情",
                        width: "800px",
                        visible: _vm.showUser
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.showUser = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "dialog-body" }, [
                        _c(
                          "div",
                          { staticClass: "userInfo" },
                          _vm._l(_vm.userInfo, function(item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "userInfo-content" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "userInfo-content-left" },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                                item.code == "userStatus"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "userInfo-content-right ellipsisspan"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.selectItem[item.code] ==
                                                "VALID"
                                                ? "有效"
                                                : "失效"
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : item.code == "mngLevel"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "userInfo-content-right ellipsisspan"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.mngInfo[
                                                _vm.selectItem[item.code]
                                              ]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : item.code == "busLinCode"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "userInfo-content-right ellipsisspan"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.dictInfo[
                                                _vm.selectItem[item.code]
                                              ]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : item.code == "jobList"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "userInfo-content-right ellipsisspan",
                                        attrs: {
                                          title: _vm.getLevelInfo(
                                            _vm.selectItem[item.code]
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getLevelInfo(
                                                _vm.selectItem[item.code]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "userInfo-content-right ellipsisspan"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.selectItem[item.code]) +
                                            " "
                                        )
                                      ]
                                    )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_page",
              attrs: {
                title: "用户角色配置(" + _vm.userSettingName + ")",
                width: "1400px",
                visible: _vm.showSetting
              },
              on: {
                "update:visible": function($event) {
                  _vm.showSetting = $event
                }
              }
            },
            [
              _c("div", { staticClass: "configure" }, [
                _c("div", { staticClass: "configure-top" }, [
                  _c(
                    "div",
                    { staticClass: "configure-top-input" },
                    [
                      _c("div", { staticClass: "configure-top-input-title" }, [
                        _vm._v("系统名称：")
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "224px" },
                          attrs: {
                            placeholder: "请选择系统名称",
                            size: "small",
                            clearable: ""
                          },
                          model: {
                            value: _vm.DialogSystemName,
                            callback: function($$v) {
                              _vm.DialogSystemName = $$v
                            },
                            expression: "DialogSystemName"
                          }
                        },
                        _vm._l(_vm.orgOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: {
                              label: item.systemName,
                              value: item.systemId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "configure-top-input" },
                    [
                      _c("div", { staticClass: "configure-top-input-title" }, [
                        _vm._v("角色名称：")
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "224px" },
                        attrs: {
                          placeholder: "请输入内容",
                          clearable: "",
                          size: "small"
                        },
                        model: {
                          value: _vm.DialogRoleName,
                          callback: function($$v) {
                            _vm.DialogRoleName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "DialogRoleName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "configure-top-btn" }, [
                    _c("input", {
                      staticClass: "btn btn-red search-btn role-top-btn-item",
                      attrs: { type: "button", value: "查询" },
                      on: { click: _vm.searchConfig }
                    })
                  ]),
                  _c("div", { staticClass: "configure-top-btn" }, [
                    _c("input", {
                      staticClass: "btn btn-red reset-btn role-top-btn-item",
                      attrs: { type: "button", value: "重置" },
                      on: { click: _vm.resetConfig }
                    })
                  ])
                ]),
                _c("div", { staticClass: "configure-content" }, [
                  _c(
                    "div",
                    { staticClass: "configure-content-left" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.fingureLoading,
                              expression: "fingureLoading"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.configureData,
                            "max-height": "450px",
                            "highlight-current-row": "",
                            "header-row-class-name": "test",
                            border: ""
                          }
                        },
                        [
                          _c("template", { slot: "empty" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "100%",
                                  width: "100%",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c("no-data", {
                                  attrs: { height: "300px", width: "300px" }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("el-table-column", {
                            attrs: {
                              prop: "roleId",
                              label: "角色编码",
                              width: "80"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(scope.row.roleId)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c("div", { staticClass: "line" }, [
                                          _vm._v(_vm._s(scope.row.roleId))
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "roleName",
                              label: "角色名称",
                              width: "108"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(scope.row.roleName)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c("div", { staticClass: "line" }, [
                                          _vm._v(_vm._s(scope.row.roleName))
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "corner",
                              label: "AB角",
                              width: "60"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(scope.row.corner)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c("div", { staticClass: "line" }, [
                                          _vm._v(_vm._s(scope.row.corner))
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "orgPathName",
                              label: "绑定部门",
                              width: "126"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(scope.row.orgPathName)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c("div", { staticClass: "line" }, [
                                          _vm._v(_vm._s(scope.row.orgPathName))
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "systemName",
                              label: "系统名称",
                              "min-width": "80"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("div", {
                                          attrs: { slot: "content" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.ToBreak(scope.row.systemName)
                                            )
                                          },
                                          slot: "content"
                                        }),
                                        _c("div", { staticClass: "line" }, [
                                          _vm._v(_vm._s(scope.row.systemName))
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c(
                            "el-table-column",
                            {
                              attrs: { width: "82" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "configure-tableLast" },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "configure-tableLast-img",
                                            attrs: {
                                              src: require("@/assets/system/edit.png"),
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.configEdit(scope)
                                              }
                                            }
                                          }),
                                          _c(
                                            "el-popconfirm",
                                            {
                                              attrs: {
                                                title: "确定删除此角色吗？"
                                              },
                                              on: {
                                                onConfirm: function($event) {
                                                  return _vm.configDelete(scope)
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "configure-tableLast-img",
                                                attrs: {
                                                  slot: "reference",
                                                  src: require("@/assets/system/del2.png"),
                                                  alt: ""
                                                },
                                                slot: "reference"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      "text-align": "center",
                                      "vertical-align": "middle",
                                      "margin-top": "5px"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "configure-tableLast-img",
                                      attrs: {
                                        src: require("@/assets/system/add.png"),
                                        alt: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.configAdd($event)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "configure-content-mid" },
                    [
                      _c("div", { staticClass: "configure-content-mid-top" }, [
                        _vm._v(" 对应权限 ")
                      ]),
                      _vm.configureData != null
                        ? _c(
                            "div",
                            { staticClass: "configure-content-mid-bot" },
                            _vm._l(_vm.configureData, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "configure-content-mid-bot-item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "configure-content-mid-bot-item-title"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.roleId + "-" + item.roleName
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "configure-content-mid-bot-item-jurisdiction"
                                    },
                                    _vm._l(item.permissionList, function(
                                      child,
                                      i
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass:
                                            "configure-content-mid-bot-item-jurisdiction-content",
                                          class: { te: i % 2 != 0 }
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: child.permissionId,
                                                placement: "top-start"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "configure-content-mid-bot-item-jurisdiction-content-code"
                                                },
                                                [
                                                  _vm._v(
                                                    " 权限编码：" +
                                                      _vm._s(
                                                        child.permissionId
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: child.permissionName,
                                                placement: "top-start"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "configure-content-mid-bot-item-jurisdiction-content-name"
                                                },
                                                [
                                                  _vm._v(
                                                    " 权限名称：" +
                                                      _vm._s(
                                                        child.permissionName
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.configureData == null
                        ? [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "80%",
                                  width: "100%",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c("no-data", {
                                  attrs: { height: "300px", width: "300px" }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "configure-content-right" },
                    [
                      _c(
                        "div",
                        { staticClass: "configure-content-right-top" },
                        [_vm._v(" 对应资源树 ")]
                      ),
                      _vm.resourceVOList != null
                        ? _c("el-tree", {
                            attrs: {
                              data: _vm.resourceVOList,
                              props: _vm.resourceProps
                            }
                          })
                        : _vm._e(),
                      _vm.resourceVOList == null
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                height: "80%",
                                width: "100%",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center"
                              }
                            },
                            [
                              _c("no-data", {
                                attrs: { height: "260px", width: "260px" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm.showOrgDialog
            ? _c(
                "div",
                [
                  _c(
                    "el-dialog",
                    {
                      directives: [
                        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                      ],
                      attrs: {
                        title: "选择机构",
                        width: "900px",
                        visible: _vm.showOrgDialog
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.showOrgDialog = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "orgDialog" }, [
                        _c("div", { staticClass: "orgDialog-top" }, [
                          _c(
                            "div",
                            { staticClass: "orgDialog-top-input " },
                            [
                              _c(
                                "div",
                                { staticClass: "orgDialog-top-input-title" },
                                [_vm._v("机构名称")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "224px" },
                                  attrs: {
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    size: "small",
                                    placeholder: "请输入机构名称",
                                    loading: _vm.loading,
                                    "remote-method": _vm.remoteMethod
                                  },
                                  model: {
                                    value: _vm.orgDialogValue,
                                    callback: function($$v) {
                                      _vm.orgDialogValue = $$v
                                    },
                                    expression: "orgDialogValue"
                                  }
                                },
                                _vm._l(_vm.orgDialogOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.orgName,
                                      value: item.orgId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "orgDialog-top-input" },
                            [
                              _c(
                                "div",
                                { staticClass: "orgDialog-top-input-title" },
                                [_vm._v("机构编号")]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "224px" },
                                attrs: {
                                  placeholder: "请输入编号",
                                  disabled: "",
                                  size: "small"
                                },
                                model: {
                                  value: _vm.orgDialogValue,
                                  callback: function($$v) {
                                    _vm.orgDialogValue =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "orgDialogValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "orgDialog-top-btn" }, [
                            _c("input", {
                              staticClass:
                                "btn btn-red search-btn role-top-btn-item",
                              attrs: { type: "button", value: "查询" },
                              on: { click: _vm.getOrg }
                            })
                          ])
                        ]),
                        _c("div", { staticClass: "orgDialog-content" }, [
                          _c("div", { staticClass: "orgDialog-content-left" }, [
                            _c(
                              "div",
                              { staticClass: "orgDialog-content-left-top" },
                              [_vm._v(" 可选择列表 ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "orgDialog-content-left-tree dict-tree"
                              },
                              [
                                _vm.dataTree && _vm.dataTree.length > 0
                                  ? _c("el-tree", {
                                      ref: "treeOrg",
                                      attrs: {
                                        "node-key": "pathId",
                                        data: _vm.dataTree,
                                        props: _vm.defaultProps,
                                        load: _vm.loadNode,
                                        "expand-on-click-node": false,
                                        lazy: ""
                                      },
                                      on: { "node-click": _vm.getOrgSelect }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "orgDialog-submit" }, [
                          _c("input", {
                            staticClass: "orgDialog-submit-cancle",
                            attrs: { type: "button", value: "取消" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.showOrgDialog = false
                              }
                            }
                          }),
                          _c("input", {
                            staticClass: "orgDialog-submit-confirm",
                            attrs: { type: "button", value: "提交" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.submitOrgDialog($event)
                              }
                            }
                          })
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showUserDialog
            ? _c(
                "div",
                [
                  _c(
                    "el-dialog",
                    {
                      directives: [
                        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                      ],
                      attrs: {
                        title: "编辑用户信息",
                        width: "560px",
                        visible: _vm.showUserDialog
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.showUserDialog = $event
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "addUser" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "editInforuleForm",
                              attrs: {
                                model: _vm.editInfo,
                                rules: _vm.editInforules,
                                "label-width": "100px",
                                "label-position": "top"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户名称：",
                                    prop: "userName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入用户名称",
                                      size: "small",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.editInfo.userName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "userName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "editInfo.userName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "职位：",
                                    prop: "jobCodeList"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        placeholder: "请输入职位关键词",
                                        "remote-method": _vm.getManageLevel,
                                        size: "small",
                                        loading: _vm.manageLoading
                                      },
                                      model: {
                                        value: _vm.editInfo.jobCodeList,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editInfo,
                                            "jobCodeList",
                                            $$v
                                          )
                                        },
                                        expression: "editInfo.jobCodeList"
                                      }
                                    },
                                    _vm._l(_vm.manageList, function(item) {
                                      return _c("el-option", {
                                        key: item.jobCode,
                                        attrs: {
                                          label: item.jobName,
                                          value: item.jobCode
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "职级：", prop: "mngLevel" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "limit32",
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择职级信息"
                                      },
                                      model: {
                                        value: _vm.editInfo.mngLevel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editInfo,
                                            "mngLevel",
                                            $$v
                                          )
                                        },
                                        expression: "editInfo.mngLevel"
                                      }
                                    },
                                    _vm._l(_vm.mngList, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "条线：", prop: "buslinCode" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "limit32",
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择条线信息"
                                      },
                                      model: {
                                        value: _vm.editInfo.busLinCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editInfo,
                                            "busLinCode",
                                            $$v
                                          )
                                        },
                                        expression: "editInfo.busLinCode"
                                      }
                                    },
                                    _vm._l(_vm.buslinList, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "联系方式：",
                                    prop: "telephone"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入联系方式",
                                      size: "small"
                                    },
                                    model: {
                                      value: _vm.editInfo.telephone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "telephone",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "editInfo.telephone"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户状态：",
                                    prop: "userStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择用户状态",
                                        size: "small"
                                      },
                                      model: {
                                        value: _vm.editInfo.userStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editInfo,
                                            "userStatus",
                                            $$v
                                          )
                                        },
                                        expression: "editInfo.userStatus"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        key: "VALID",
                                        attrs: { value: "VALID", label: "有效" }
                                      }),
                                      _c("el-option", {
                                        key: "INVALID",
                                        attrs: {
                                          value: "INVALID",
                                          label: "失效"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "orgDialog-submit" },
                            [
                              _c("input", {
                                staticClass: "orgDialog-submit-cancle",
                                attrs: { type: "button", value: "取消" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.showUserDialog = false
                                  }
                                }
                              }),
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "确认修改此用户信息?" },
                                  on: {
                                    onConfirm: function($event) {
                                      return _vm.confirmsureedite(true)
                                    },
                                    onCancel: function($event) {
                                      return _vm.confirmsureedite(false)
                                    }
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "orgDialog-submit-confirm",
                                    attrs: {
                                      slot: "reference",
                                      type: "button",
                                      value: "提交"
                                    },
                                    slot: "reference"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showAddUserDialog
            ? _c(
                "div",
                [
                  _c(
                    "el-dialog",
                    {
                      directives: [
                        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                      ],
                      attrs: {
                        title: "新增用户",
                        width: "660px",
                        visible: _vm.showAddUserDialog
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.showAddUserDialog = $event
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "addUser",
                          staticStyle: { padding: "0" }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "ruleForm",
                              attrs: {
                                model: _vm.newUserInfo,
                                rules: _vm.rules,
                                "label-width": "100px",
                                "label-position": "top"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-around"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "280px" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "用户名称：",
                                            prop: "userName"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "limit32",
                                            attrs: {
                                              maxlength: "32",
                                              "show-word-limit": "",
                                              placeholder: "请输入用户名称",
                                              size: "small"
                                            },
                                            model: {
                                              value: _vm.newUserInfo.userName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newUserInfo,
                                                  "userName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "newUserInfo.userName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "用户编号：",
                                            prop: "userId"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "limit32",
                                            attrs: {
                                              size: "small",
                                              maxlength: "32",
                                              "show-word-limit": "",
                                              placeholder: "请输入用户编号"
                                            },
                                            model: {
                                              value: _vm.newUserInfo.userId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newUserInfo,
                                                  "userId",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "newUserInfo.userId"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "邮箱地址：",
                                            prop: "mail"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "limit32",
                                            attrs: {
                                              size: "small",
                                              maxlength: "32",
                                              "show-word-limit": "",
                                              placeholder: "请输入用户编号"
                                            },
                                            model: {
                                              value: _vm.newUserInfo.mail,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newUserInfo,
                                                  "mail",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "newUserInfo.mail"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "pathName" } },
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c(
                                              "div",
                                              { staticClass: "Organization" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Organization-required"
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v("所属机构：")
                                              ]
                                            )
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "org-select ellipsisspan",
                                              class: {
                                                color6: _vm.orgSelectList != ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showOrgDialog = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.orgSelectList == ""
                                                      ? "请选择所属机构"
                                                      : _vm.orgSelectList
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "职位：",
                                            prop: "jobCodeList"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                multiple: "",
                                                filterable: "",
                                                remote: "",
                                                "reserve-keyword": "",
                                                placeholder: "请输入职位关键词",
                                                "remote-method":
                                                  _vm.getManageLevel,
                                                size: "small",
                                                loading: _vm.manageLoading
                                              },
                                              model: {
                                                value:
                                                  _vm.newUserInfo.jobCodeList,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newUserInfo,
                                                    "jobCodeList",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newUserInfo.jobCodeList"
                                              }
                                            },
                                            _vm._l(_vm.manageList, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.jobCode,
                                                attrs: {
                                                  label: item.jobName,
                                                  value: item.jobCode
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { width: "280px" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "职级：",
                                            prop: "mngLevel"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "limit32",
                                              attrs: {
                                                size: "small",
                                                placeholder: "请选择职级信息"
                                              },
                                              model: {
                                                value: _vm.newUserInfo.mngLevel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newUserInfo,
                                                    "mngLevel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newUserInfo.mngLevel"
                                              }
                                            },
                                            _vm._l(_vm.mngList, function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  value: item.key,
                                                  label: item.value
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "条线：",
                                            prop: "buslinCode"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "limit32",
                                              attrs: {
                                                size: "small",
                                                placeholder: "请选择条线信息"
                                              },
                                              model: {
                                                value:
                                                  _vm.newUserInfo.buslinCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newUserInfo,
                                                    "buslinCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newUserInfo.buslinCode"
                                              }
                                            },
                                            _vm._l(_vm.buslinList, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  value: item.key,
                                                  label: item.value
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "联系方式：",
                                            prop: "telephone"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              onkeyup:
                                                "this.value = this.value.replace(/[^\\d.]/g,'');",
                                              maxlength: "16",
                                              "show-word-limit": "",
                                              placeholder: "请输入联系方式",
                                              size: "small"
                                            },
                                            model: {
                                              value: _vm.newUserInfo.telephone,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newUserInfo,
                                                  "telephone",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "newUserInfo.telephone"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "用户状态：",
                                            prop: "userStatus"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择用户状态",
                                                size: "small"
                                              },
                                              model: {
                                                value:
                                                  _vm.newUserInfo.userStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newUserInfo,
                                                    "userStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newUserInfo.userStatus"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                key: "VALID",
                                                attrs: {
                                                  value: "VALID",
                                                  label: "有效"
                                                }
                                              }),
                                              _c("el-option", {
                                                key: "INVALID",
                                                attrs: {
                                                  value: "INVALID",
                                                  label: "失效"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "orgDialog-submit" },
                            [
                              _c("input", {
                                staticClass: "orgDialog-submit-cancle",
                                attrs: { type: "button", value: "取消" },
                                on: {
                                  click: function($event) {
                                    _vm.showAddUserDialog = false
                                  }
                                }
                              }),
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "确认添加此用户信息?" },
                                  on: {
                                    onConfirm: function($event) {
                                      return _vm.confirmsureadd(true)
                                    },
                                    onCancel: function($event) {
                                      return _vm.confirmsureadd(false)
                                    }
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "orgDialog-submit-confirm",
                                    attrs: {
                                      slot: "reference",
                                      type: "button",
                                      value: "提交"
                                    },
                                    slot: "reference"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                title: "同步用户",
                width: "78%",
                visible: _vm.synchronization
              },
              on: {
                "update:visible": function($event) {
                  _vm.synchronization = $event
                }
              }
            },
            [
              _c("div", { staticClass: "synchron" }, [
                _c("div", { staticClass: "synchron-top" }, [
                  _c(
                    "div",
                    { staticClass: "synchron-top-user" },
                    [
                      _c("div", { staticClass: "synchron-top-user-num" }, [
                        _vm._v("用户编号")
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "224px" },
                        attrs: { placeholder: "请输入编号", size: "small" },
                        model: {
                          value: _vm.input,
                          callback: function($$v) {
                            _vm.input = $$v
                          },
                          expression: "input"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "synchron-top-btn" }, [
                    _c("input", {
                      staticClass: "btn btn-red search-btn role-top-btn-item",
                      attrs: { type: "button", value: "查询" },
                      on: { click: _vm.searchForm }
                    }),
                    _c("input", {
                      staticClass: "btn btn-red op-syn role-top-btn-item",
                      attrs: { type: "button", value: "同步" },
                      on: { click: _vm.sync }
                    })
                  ])
                ]),
                _c("div", { staticClass: "synchron-content" }, [
                  _c("div", { staticClass: "synchron-content-left" }, [
                    _c("div", { staticClass: "synchron-content-left-title" }, [
                      _vm._v("现有用户信息")
                    ]),
                    _c(
                      "div",
                      { staticClass: "userInfo" },
                      _vm._l(_vm.userInfo, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "userInfo-content" },
                          [
                            _c(
                              "div",
                              { staticClass: "userInfo-content-left" },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "userInfo-content-right" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.selectItem[item.code]) + " "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _c("div", { staticClass: "synchron-content-right" }, [
                    _c("div", { staticClass: "synchron-content-right-title" }, [
                      _vm._v("最新用户信息")
                    ]),
                    _c(
                      "div",
                      { staticClass: "userInfo" },
                      _vm._l(_vm.userInfo, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "userInfo-content" },
                          [
                            _c(
                              "div",
                              { staticClass: "userInfo-content-left" },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "userInfo-content-right" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.selectItem[item.code]) + " "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm.editPermissions
            ? _c(
                "div",
                [
                  _c(
                    "el-dialog",
                    {
                      directives: [
                        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                      ],
                      attrs: {
                        title: _vm.configTitle,
                        width: "620px",
                        visible: _vm.editPermissions,
                        top: "10vh"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.editPermissions = $event
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "editPermission" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "editPermissionForm",
                              attrs: {
                                model: _vm.editPermisiongForm,
                                rules: _vm.rulesEdit,
                                "label-width": "120px",
                                "label-position": "top"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户名称：",
                                    prop: "userName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请输入用户名称",
                                      size: "small"
                                    },
                                    model: {
                                      value: _vm.editPermisiongForm.userName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editPermisiongForm,
                                          "userName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "editPermisiongForm.userName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "用户编号：", prop: "userId" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      disabled: "",
                                      placeholder: "请输入用户编号"
                                    },
                                    model: {
                                      value: _vm.editPermisiongForm.userId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editPermisiongForm,
                                          "userId",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "editPermisiongForm.userId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "系统名称：",
                                    prop: "systemId"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择系统名称"
                                      },
                                      on: { change: _vm.changeSystemId },
                                      model: {
                                        value: _vm.editPermisiongForm.systemId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPermisiongForm,
                                            "systemId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "editPermisiongForm.systemId"
                                      }
                                    },
                                    _vm._l(_vm.systemList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          value: item.value,
                                          label: item.label
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "角色名称：",
                                    prop: "roleName"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        "value-key": "roleName",
                                        size: "small",
                                        placeholder: "请选择角色名称"
                                      },
                                      on: { change: _vm.getRoleId },
                                      model: {
                                        value: _vm.editPermisiongForm.roleName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPermisiongForm,
                                            "roleName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "editPermisiongForm.roleName"
                                      }
                                    },
                                    _vm._l(_vm.roleList, function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          value: item,
                                          label: item.roleName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "角色编号：", prop: "roleId" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      disabled: "",
                                      placeholder: "请输入用户编号"
                                    },
                                    model: {
                                      value: _vm.editPermisiongForm.roleId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editPermisiongForm,
                                          "roleId",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "editPermisiongForm.roleId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "AB角：", prop: "corner" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择角色"
                                      },
                                      model: {
                                        value: _vm.editPermisiongForm.corner,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editPermisiongForm,
                                            "corner",
                                            $$v
                                          )
                                        },
                                        expression: "editPermisiongForm.corner"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        key: "A",
                                        attrs: { value: "A", label: "A角" }
                                      }),
                                      _c("el-option", {
                                        key: "B",
                                        attrs: { value: "B", label: "B角" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.isshowdependOrg
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "角色生效部门：",
                                        prop: "orgPathName",
                                        required: _vm.isshowdependOrg,
                                        "show-message": false
                                      }
                                    },
                                    [
                                      _c("org-select", {
                                        attrs: {
                                          rootOrgId: _vm.topId,
                                          multiple: true,
                                          modal: false,
                                          placeholder: "请选择拟稿部门"
                                        },
                                        model: {
                                          value: _vm.editOrgPath,
                                          callback: function($$v) {
                                            _vm.editOrgPath = $$v
                                          },
                                          expression: "editOrgPath"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("div", { staticClass: "orgDialog-submit" }, [
                            _c("input", {
                              staticClass: "orgDialog-submit-cancle",
                              attrs: { type: "button", value: "取消" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.editPermissions = false
                                }
                              }
                            }),
                            _c("input", {
                              staticClass: "orgDialog-submit-confirm",
                              attrs: { type: "button", value: "提交" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.subEditPermissions($event)
                                }
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除用户",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选用户吗？",
              tips2: "删除用户后无法恢复，是否要删除用户"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: _vm.delRole
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }